import { FC } from 'react';
import Link from 'next/link';
import { alphabet } from '@/helpers/variables';
import styles from './Alphabet.module.scss';

interface IAlphabetProps {
  letterSign?: string;
  baseUrl: string;
}

const Alphabet: FC<IAlphabetProps> = ({ letterSign, baseUrl }) => {
  return (
    <>
      <div className={styles.b_alphabet}>
        {!!letterSign && letterSign.length > 0 && (
          <Link prefetch={false} href={baseUrl.split('/letter/')[0]}>
            <img src="/images/turn_left.png" />
          </Link>
        )}
        {Object.entries(alphabet)
          .slice(0, 32)
          .map(([key, subject], i) => (
            <span key={i}>
              {String(subject) === letterSign ? (
                <span className={styles.b_alphabet_current}>{subject}</span>
              ) : (
                <Link prefetch={false} href={`${baseUrl}${key}`}>
                  {subject}
                </Link>
              )}
            </span>
          ))}
      </div>
      <div className={styles.b_alphabet}>
        {Object.entries(alphabet)
          .slice(32, 58)
          .map(([key, subject], i) => (
            <span key={i}>
              {String(subject) === letterSign ? (
                <span className={styles.b_alphabet_current}>{subject}</span>
              ) : (
                <Link prefetch={false} href={`${baseUrl}${key}`}>
                  {subject}
                </Link>
              )}
            </span>
          ))}
      </div>
    </>
  );
};

export default Alphabet;
